export function RollbackClock() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.375 4.87451V8.62451L12.375 11.6245"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 2.24951V5.24951H6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 8.62451C2.25 12.5595 5.43997 15.7495 9.375 15.7495C13.31 15.7495 16.5 12.5595 16.5 8.62451C16.5 4.68948 13.31 1.49951 9.375 1.49951C6.66106 1.49951 4.30153 3.01687 3.09848 5.24951L3.17696 5.10776"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
